import React, {
    useEffect,
    useLayoutEffect, useRef,
    useState,
} from 'react';

import { coachingAPI } from 'api/coachingAPI';
import useGetCoachingData from 'hooks/useGetCoachingData';
import { isEmpty } from 'lodash';
import {useLocation, useNavigate} from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { activeSubmit } from 'state';
import styled from 'styled-components';
import {fadeIn} from "../../../../../styled/StyledComponent";

interface StyledComponentProps {
    width?: string;
    display?: string;
    justifyContent?: string;
}

const About = () => {
    const navigate = useNavigate();
    const [text, setText] = useState("");
    const setSubmit = useSetRecoilState(activeSubmit);
    const {
        state: { createId },
    } = useLocation();
    const { data: coachingData, stepData } = useGetCoachingData(createId, "getClassById");

    const putMessage = async () => {
        try {
            await coachingAPI.putCoachingAbout(createId, {
                data: {
                    about: text,
                },
            })
        }catch (e) {
            console.log((e))
        }finally {
            navigate("/create_coaching/showcase",{
                state:{
                    createId:createId
                }
            })
        }

    };

    useLayoutEffect(() => {
        if (!isEmpty(coachingData?.coaching?.about)) {
            setText(coachingData?.coaching?.about);
        }
    }, [coachingData?.coaching?.about]);

    useEffect(() => {
        setSubmit(true);
    }, []);

    const titleInputRef = useRef(null);

    useEffect(() => {
        titleInputRef?.current?.focus()
    }, [titleInputRef?.current]);

    console.log("coachingData", coachingData);

    return (
        <Container>
            <Contents>
                <Row style={{ marginBottom: 0 }}>
                    <FormBox>
                        <dt>
                          About this Coaching
                            {/*<strong>*</strong>*/}
                        </dt>
                        <p>
                        Describe the practical benefits of your coaching that will help students solve their problems and achieve their goals.
                        </p>
                        <dd>
                            <FormBoxItemWrap>
                                <li>
                                    <FormItem style={{ width: "calc(100%)" }}>
                                        <textarea
                                            ref={titleInputRef}
                                            value={text}
                                            onChange={(e) => {
                                                setText(e.target.value);
                                            }}
                                            style={{ height: 240 }}
                                            maxLength={1000}
                                            placeholder="What topics do you specialize in?
What kind of value do your coaching sessions offer?
Do you have any unique experience or knowledge that sets you apart from others?"
                                        />
                                        <TextLength>{1000 - text.length}</TextLength>
                                    </FormItem>
                                </li>
                            </FormBoxItemWrap>
                        </dd>
                    </FormBox>
                </Row>
            </Contents>
            <ButtonItems onClick={putMessage} justifyContent={"flex-end"}>
                <Browse
                    className={"prev"}
                    style={{ marginRight: 15, width: 100, height: 40 }}>
                    <span style={{ marginLeft: 0 }}>Previous</span>
                </Browse>
                <button
                    className={"continue"}
                >Continue</button>
            </ButtonItems>
        </Container>
    );
};
export default About;

const Container = styled.div`
    //overflow-y: scroll;
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const Contents = styled.div`
    padding: 20px 20px 20px 20px;
`;

const Row = styled.div<StyledComponentProps>`
    display: ${(props) => props.display};
    justify-content: space-between;
    margin-bottom: 15px;
`;
const Col = styled.div<StyledComponentProps>`
    width: calc((100% - 18px) / 2);
`;
const Divider = styled.div`
    width: calc(140%);
    transform: translateX(-20%);
    height: 1px;
    background: #333;
    opacity: 0.3;
`;
const FormBox = styled.dl`
    p{
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px;
        color: #333;
        margin-bottom: 16px;
    }
    > dt {
        color: #333;
        font-family: "Europa-Bold";
        font-size: 26px;
        font-style: normal;
        font-weight: 700;
        line-height: 26px;
        //letter-spacing: 0.52px;
        margin-bottom: 16px;
        > strong {
            font-size: 14px;
            line-height: 35px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`;
const FormBoxItemWrap = styled.ul`
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
`;

const FormItem = styled.div`
    h2 {
        font-size: 14px;
        margin-bottom: 15px;
    }
    position: relative;
    > input[type="text"],
    select,
    textarea {
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 16px;
        resize: none;
        &::placeholder {
            color: #ddd;
            line-height: 22px;
        }
    }
    > input[type="text"] {
        height: 48px;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
`;

const SelectArrow = styled.div`
    position: absolute;
    right: 16px;
    top: 15px;
`;

const ThumbnailWrap = styled.div`
    color: #333;
    font-size: 16px;
`;

const ThumbnailTitle = styled.h5`
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    > strong {
        font-size: 13px;
        font-weight: 600;
        color: #da1414;
        display: inline-block;
        margin-left: 1px;
        vertical-align: top;
    }
`;

const ThumbnailText = styled.p`
    margin-bottom: 15px;
    line-height: 22px;
`;

const ThumbnailUpload = styled.div`
    width: 100%;
    height: 180px;
    padding: 9px 8px;
    border: 1px dashed rgba(51, 51, 51, 0.6);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        padding: 0;
        border: 0;
        background: none;
        line-height: 0;
        cursor: pointer;
    }
`;

const ThumbnailView = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &::after {
        width: 100%;
        height: 100%;
        position: absolute;
        background: #000;
        opacity: 0.5;
        content: "";
    }
`;

const ThumbnailButtonList = styled.ul`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    > li {
        margin: 0 4px;
    }
`;

const ThumbnailUploadButton = styled.button`
    width: 100%;
    height: 100%;
    > span {
        display: block;
        font-size: 18px;
        font-family: Europa-Regular;
        margin-top: 10px;
        line-height: 100%;
    }
`;

const ButtonItems = styled.div<StyledComponentProps>`
    padding: 25px 20px;
    display: flex;
    justify-content: space-between;
    border-top: solid 1px rgba(51, 51, 51, 0.3);
    button {
        width: 100px;
        height: 40px;
        border: 0;
        cursor: pointer;
        padding: 11px 15px 11px 14px;
        color: #fff;
        border-radius: 6px;
        background: #ddc160;
    }
`;

const FormItems = styled.div`
    border: solid 1px #33333360;
    border-radius: 15px;
    overflow: hidden;
`;
const FormInner = styled.div`
    padding: 15px 15px 10px 15px;
    position: relative;
`;
const FormItemDivider = styled.div`
    width: 100%;
    height: 1px;
    background: #33333360;
`;
const VideoItemsWrap = styled.div`
    padding: 30px 15px 20px 15px;
    h2 {
        color: "#000";
        margin-bottom: 3px;
        font-size: 16px;
        font-weight: 400;
    }
`;
const VideoItems = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;
`;
const CheckBox = styled.div`
    display: flex;
    margin-right: 13px;
    align-items: center;
    span {
        padding-top: 2px;
        font-size: 16px;
        color: #212529;
    }
    div {
        margin-right: 8px;
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: solid 1px #333;
    }
`;
const Browse = styled.div`
    height: 48px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;
    flex: 1;
    width: 100%;
    min-width: 120px;
    max-width: 120px;
    transition: all 0.2s;
    &:hover{
        background: #333;
        span{
            color: #fff;
        }
    }
    &.prev{
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        padding: 0!important;
    }
    span {
        margin-left: 10px;
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;
const CloseButton = styled.div`
    background: #333;
    position: absolute;
    right: 0;
    top: 0;
    width: 51px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;
const RemoveButton = styled.div``;

const AddButton = styled.div`
    height: 48px;
    border-radius: 8px;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;

    width: 129px;
`;

const AddChapter = styled.div`
    background: #333;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    width: 106px;
    height: 40px;
    justify-content: center;
    border-radius: 5px;
    margin-top: 15px;
    cursor: pointer;
    span {
        color: #fff;
        font-size: 18px;
        margin-right: 10px;
        font-weight: 400;
    }
`;

const Transcript = styled.div`
    h3 {
        margin-top: 20px;
        margin-bottom: 14px;
        font-size: 26px;
        font-weight: 700;
    }
`;
